import React from 'react';
import styled from 'styled-components';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { Input, Form, Button, Row, Space } from 'antd';
import { useIntl, FormattedMessage } from 'react-intl';

const styleIcon = (icon: typeof MailOutlined) => styled(icon)`
  font-size: 18px;
  font-weight: bold;
  color: ${(props) => props.theme.iconColor};
`;

const StyledMailOutlined = styleIcon(MailOutlined);
const StyledLockOutlined = styleIcon(LockOutlined);

const LoginInput = styled(Input)`
  height: 56px;
  border-radius: 2px;
  .ant-input {
    font-size: 18px;
    border: none;
  }
  .ant-input:not(:first-child) {
    padding-left: 20px !important;
  }
`;

export type LoginFormValues = {
  email: string;
  password: string;
};

const LoginForm: React.FC<{ onLogin: (values: LoginFormValues) => void }> = ({
  onLogin,
}) => {
  const intl = useIntl();
  const [form] = Form.useForm<LoginFormValues>();

  return (
    <Form
      form={form}
      onFinish={(values) => {
        onLogin({
          email: values.email.trim().toLowerCase(),
          password: values.password.trim(),
        });
      }}
      layout="vertical"
    >
      <Space direction="vertical" css="width: 100%;row-gap:0px" size="middle">
        <Form.Item
          name="email"
          rules={[
            {
              required: true,
              message: intl.formatMessage({
                defaultMessage:
                  'No email provided. Please enter your email address.',
              }),
            },
          ]}
        >
          <LoginInput
            size="large"
            prefix={<StyledMailOutlined />}
            placeholder={intl.formatMessage({ defaultMessage: 'Email' })}
          />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[
            {
              required: true,
              message: intl.formatMessage({
                defaultMessage:
                  'No password provided. Please enter your password.',
              }),
            },
          ]}
        >
          <LoginInput
            size="large"
            type="password"
            prefix={<StyledLockOutlined />}
            placeholder={intl.formatMessage({ defaultMessage: 'Password' })}
          />
        </Form.Item>
      </Space>
      <Form.Item css="margin: 0">
        <a href="/forgot-password">
          <FormattedMessage defaultMessage="Forgot your password?" />
        </a>
      </Form.Item>
      <Row justify="end" css="padding: 10px 0px;">
        <Button type="primary" htmlType="submit">
          <FormattedMessage defaultMessage="Login" />
        </Button>
      </Row>
    </Form>
  );
};

export default LoginForm;
